import { type EditorPlugin } from '../../types/aha-editor';

const DividerLineSchemaPlugin: EditorPlugin = {
  name: 'Divider line schema plugin',
  schema: {
    'divider-line': {
      isVoid: true,
    },
  },
};

export default DividerLineSchemaPlugin;
